import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { CountriesEntity } from './countries.entity';
import { SupportedPaymentMethodTypeFeeStateEntity } from './supported-payment-method-type-fee-state.entity';
import { SupportedPaymentMethodTypeStateEntity } from './supported-payment-method-type-state.entity';

@Index('idx_active', ['active'], {})
@Index('idx_country_code', ['countryCode'], {})
@Index('unique_code_country', ['code', 'countryCode'], { unique: true })
@Entity('states_provinces')
export class StatesProvincesEntity extends BaseEntity {
	@Column('varchar', { name: 'code', length: 10 })
	public code!: string;

	@Column('varchar', { name: 'name', length: 100 })
	public name!: string;

	@Column('varchar', { name: 'country_code', length: 2 })
	public countryCode!: string;

	@Column('enum', {
		name: 'type',
		enum: ['state', 'province', 'territory', 'district', 'region'],
	})
	public type!: 'state' | 'province' | 'territory' | 'district' | 'region';

	@Column('tinyint', {
		name: 'active',
		nullable: true,
		width: 1,
		default: () => "'1'",
	})
	public active!: boolean | null;

	@ManyToOne(() => CountriesEntity, (countries) => countries.statesProvinces, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: 'country_code', referencedColumnName: 'code' }])
	public countryCode2!: CountriesEntity;

	@OneToMany(
		() => SupportedPaymentMethodTypeFeeStateEntity,
		(supportedPaymentMethodTypeFeeState) =>
			supportedPaymentMethodTypeFeeState.fkStateProvince,
		{},
	)
	public supportedPaymentMethodTypeFeeStates!: Array<SupportedPaymentMethodTypeFeeStateEntity>;

	@OneToMany(
		() => SupportedPaymentMethodTypeStateEntity,
		(supportedPaymentMethodTypeState) =>
			supportedPaymentMethodTypeState.fkStateProvince,
		{},
	)
	public supportedPaymentMethodTypeStates!: Array<SupportedPaymentMethodTypeStateEntity>;
}
